import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'


const Footer = () => {
  return (
    <Box sx={{ 
      bgcolor: '#f8f9fa', 
      py: 3, 
      borderTop: 1, 
      borderColor: 'divider'
    }}>
      <Container>
        <Stack 
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Layer X. All rights reserved.
          </Typography>
          <Box>
            <Button 
              component="a" 
              href="mailto:hello@layerx.ca"
              size="small"
              sx={{ color: 'text.secondary', textTransform: 'none' }}
            >
              hello@layerx.ca
            </Button>
          </Box>
        </Stack>
      </Container>
    </Box>
  )
}
export default Footer
